import { type Client, graphql, prefetch } from "@opensea/graphql"
import { ActivityItemCardFragment } from "@/components/collection/explore/components/ActivityItemCard/ActivityItemCard.fragment"

export const CollectionRecentSalesQuery = graphql(
  `
    query CollectionRecentSalesQuery($collectionSlug: String!) {
      collectionActivity(
        filter: { activityTypes: [SALE] }
        collectionSlug: $collectionSlug
        limit: 10
      ) {
        items {
          id
          ...ActivityItemCard
        }
      }
    }
  `,
  [ActivityItemCardFragment],
)

export const prefetchCollectionRecentSalesQuery = (
  collectionSlug: string,
  client: Client,
) => {
  prefetch(client, CollectionRecentSalesQuery, { collectionSlug })
}
